module.exports = "/assets/data/bb72b00c3f23c0adad9ac69f9188b0ea-L13.data.json";